import type { EscalationRule, EscalationRuleBase } from "../../types";
import { createBaseService } from "./baseService";

const base = createBaseService<EscalationRule, EscalationRuleBase>({
  tableName: "escalation_rules",
  viewName: "escalation_rules_enriched",
  searchColumns: ["name"],
  computedColumns: ["targetUserName", "targetTeamName"],
});

export class EscalationRuleService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static update = base.update;
  static delete = base.delete;
}
